import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class Store extends EventDrivenStore {
  constructor() {
    super('appData', {
      data: null,
      loading: true,
      error: null
    });
  }

  async setupEvents() {
    this.on(constants.EVENTS.APP_DATA.REFRESHED, (data) => {
      this.state.data = data;
      this.state.loading = false;
      this.state.error = null;
    });

    this.on(constants.EVENTS.APP_DATA.REFRESH_ERROR, (error) => {
      this.state.loading = false;
      this.state.error = error?.message || error;
    });

    this.on(constants.EVENTS.APP_DATA.REFRESHING, () => {
      this.updateState({ loading: true });
    });
  }
}

// new Store();
export default Store;